export default () => {
	const megaMenuLinks = document.querySelectorAll(
		'.js-mega-menu-dropdown-button'
	);
	const megaMenus = document.querySelectorAll('.js-mega-menu');
	const mobileMenuOpen = document.getElementById('js-mobile-menu-open');
	const mobileMenuClose = document.getElementById('js-mobile-menu-close');
	const menuOverlay = document.getElementById('js-menu-overlay');
	//Set overlay height to the height of the document.
	menuOverlay.style.height = document.documentElement.scrollHeight + 'px';

	//Setup click listeners on each
	megaMenuLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			menuOverlay.classList.add('hidden');
			closeOtherMenus(megaMenuLinks, e);
			toggleMenu(e, menuOverlay, megaMenuLinks);
		});
	});

	//Set up click listeners on all the SVGs within each megaMenuLink so that when clicked the parent is clicked.
	megaMenuLinks.forEach((link) => {
		const svg = link.querySelector('svg');
		svg.addEventListener('click', (e) => {
			e.stopPropagation();
			link.click();
		});
	});

	//Close the mega menu if the user clicks outside of it.
	document.addEventListener('click', (e) => {
		const isInsideMegaMenu = Array.from(megaMenus).some((menu) =>
			menu.contains(e.target)
		);
		if (!isInsideMegaMenu) {
			handleClickOutside(megaMenuLinks, megaMenus, e, menuOverlay);
		}
	});

	// If the screen is resized to below 728px then close all meha menus.
	window.addEventListener('resize', () => {
		if (window.innerWidth < 728) {
			//Close all mega menus
			megaMenus.forEach((menu) => {
				menu.classList.add('hidden');
			});
			menuOverlay.classList.add('hidden');
		}
	});

	//Show the mobile menu.
	mobileMenuOpen.addEventListener('click', (e) => {
		e.preventDefault();
		const mobileMenu = document.getElementById('navigation-level-1');
		mobileMenu.classList.toggle('invisible');
	});

	//Hide the mobile menu.
	mobileMenuClose.addEventListener('click', (e) => {
		e.preventDefault();
		const mobileMenu = document.getElementById('navigation-level-1');
		mobileMenu.classList.toggle('invisible');
	});
};

const toggleMenu = (e, menuOverlay, megaMenuLinks) => {
	//Grab the data-target
	const target = e.target.getAttribute('data-target');
	//Show the menu with ID mega-menu-[target]
	const menu = document.getElementById(`mega-menu-${target}`);
	//Toggle the aria-expanded attribute on the button
	e.target.setAttribute(
		'aria-expanded',
		e.target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
	);
	//Taget the SVG within the button and toggle the rotate-180 class
	const svg = e.target.querySelector('svg');
	svg.classList.toggle('rotate-180');
	//Toggle the hidden class on the menu
	menu.classList.toggle('hidden');

	//Toggle the hidden class on the overlay
	if (menu.classList.contains('hidden')) {
		menuOverlay.classList.add('hidden');
	} else {
		menuOverlay.classList.remove('hidden');
	}

	megaMenuLinks.forEach((link) => {
		//set tab index -1
		link.setAttribute('tabindex', '-1');
	});
};

const closeOtherMenus = (megaMenuLinks, e) => {
	megaMenuLinks.forEach((link) => {
		if (link !== e.target) {
			link.setAttribute('aria-expanded', 'false');
			const svg = link.querySelector('svg');
			svg.classList.remove('rotate-180');
			//Target the menu for that link and add the hidden class
			const target = link.getAttribute('data-target');
			const menu = document.getElementById(`mega-menu-${target}`);
			menu.classList.add('hidden');
		}
	});
};

const handleClickOutside = (megaMenuLinks, megaMenus, e, menuOverlay) => {
	megaMenus.forEach(function (menu) {
		// Check if the clicked element or any of its ancestors contain the .js-mega-menu class
		const isClickInsideMenu = menu.contains(e.target);

		// If the click is outside of the .js-mega-menu and not within its children, perform your action (e.g., close the navigation)
		if (!isClickInsideMenu && !menu.contains(e.target)) {
			// Perform your action here
			closeOtherMenus(megaMenuLinks, e);
		}
	});
	menuOverlay.classList.add('hidden');
};

//If a menu is open and the user presses escape we need to close the menu and return focus to the link associated with the menu.
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape') {
		const megaMenuLinks = document.querySelectorAll(
			'.js-mega-menu-dropdown-button'
		);
		megaMenuLinks.forEach((link) => {
			if (link.getAttribute('aria-expanded') === 'true') {
				link.focus();
			}
		});
		const megaMenus = document.querySelectorAll('.js-mega-menu');
		const menuOverlay = document.getElementById('js-menu-overlay');
		closeOtherMenus(megaMenuLinks, e);
		megaMenus.forEach((menu) => {
			menu.classList.add('hidden');
		});
		menuOverlay.classList.add('hidden');

		megaMenuLinks.forEach((link) => {
			link.setAttribute('tabindex', '0');
		});
	}
});
